import React from 'react';

const UnCheckedIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="2" width="20" height="20" rx="4" stroke="#C1C5C1" strokeWidth="2" />
    </svg>
);

export default UnCheckedIcon;